// extracted by mini-css-extract-plugin
module.exports = {"containerRoot":"styles_containerRoot__Twu8f","containerAds":"styles_containerAds__L8h17"};